import baseApi from "./base";

// 获取分类列表
const fetchClassifications = () =>
  baseApi.request({
    method: 'get',
    url: '/classifications'
  })

// 新建分类
const createClassification = data =>
  baseApi.request({
    method: 'post',
    url: '/classifications',
    data
  })

// 获取父类属性
const fetchParentAttributes = parentId =>
  baseApi.request({
    method: 'get',
    url: `/classifications/attributes/${parentId}`
  })

// 删除分类
const deleteClassifications = data =>
  baseApi.request({
    method: 'delete',
    url: '/classifications',
    data
  })

// 修改分类
const modifyClassification = (id, data) =>
  baseApi.request({
    method: 'patch',
    url: `/classifications/${id}`,
    data
  })

// 获取单个详情
const fetchClassification = id =>
  baseApi.request({
    method: 'get',
    url: `/classifications/${id}`
  })

// 获取分类关联关系列表
const fetchClaRelations = (claId, params) =>
  baseApi.request({
    method: 'get',
    url: `/classifications/${claId}/relations`,
    params
  })

// 删除分类关系类型
const deleteClaRelations = data =>
  baseApi.request({
    method: 'delete',
    url: '/classifications/relations',
    data
  })

// 修改分类关系类型
const modifyClaRelations = (claId, data) =>
  baseApi.request({
    method: 'patch',
    url: `/classifications/${claId}/relations`,
    data
  })

// 添加分类关系类型
const createClaRelation = (claId, data) =>
  baseApi.request({
    method: 'post',
    url: `/classifications/${claId}/relations`,
    data
  })

// 获取显示列
const fetchColumns = id =>
  baseApi.request({
    method: 'get',
    url: `/classifications/${id}/columns`
  });

// 修改显示列
const modifyColumns = (id, data) =>
  baseApi.request({
    method: 'patch',
    url: `/classifications/${id}/columns`,
    data
  });

//复制分类
const copyClassification = id =>
  baseApi.request({
    method: 'PUT',
    url: `/classifications/${id}/copy`
  });

export {
  fetchClassifications,
  createClassification,
  fetchParentAttributes,
  deleteClassifications,
  modifyClassification,
  fetchClassification,
  fetchClaRelations,
  deleteClaRelations,
  modifyClaRelations,
  createClaRelation,
  fetchColumns,
  modifyColumns,
  copyClassification
}


// WEBPACK FOOTER //
// ./src/api/classification.js